import { get, post } from '../utils/api';
import { setToken } from '../utils/api';

/**
 * 钱包服务
 */
export const walletService = {
  // 获取签名消息
  getSignMessage: async (walletAddress) => {
    const response = await get('/wallet/message', { walletAddress });
    // 后端返回的数据结构：{ code, message, data: "消息内容" }
    // 需要返回data字段中的消息字符串
    return response.data || response.message || '';
  },

  // 钱包连接和签名验证
  connectWallet: async (walletAddress, chainId, message, signature, inviteCode = null) => {
    const requestData = {
      walletAddress,
      chainId,
      message,
      signature,
    };
    
    // 如果有邀请码，添加到请求中
    if (inviteCode) {
      requestData.inviteCode = inviteCode;
    }
    
    const response = await post('/wallet/connect', requestData);
    
    // 后端返回的数据结构：{ code, message, data: { token, user } }
    // response已经是解析后的JSON对象
    const result = response.data || response;
    
    if (result && result.token) {
      setToken(result.token);
    }
    
    // 返回完整的响应数据（包括user对象和token）
    // 确保返回的数据结构统一：{ token, user }
    return result;
  },
};

